// ImpactSection.jsx
import React from "react";
import "./ImpactSection.css";
import { motion } from "framer-motion";

const ImpactSection = ({ impacts = [] }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="impact-container">
        <h2 className="section-title-impact">ROI & MEASURABLE IMPACT</h2>
        
        <div className="impact-grid">
          {impacts.map((item, index) => (
            <motion.div
              key={index}
              className="impact-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
              viewport={{ once: false }}
            >
              <div className="value">{item.value}</div>
              <div className="label">{item.label}</div>
              <div className="source">{item.source}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default ImpactSection;